/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/image/image-cache.directive';
import * as import2 from '../../ui-elements/image/cached-image.service';
import * as import3 from '@angular/common';
import * as import4 from '../../orchestration/responsive.directive';
import * as import5 from '../../orchestration/responsive.service';
import * as import6 from '../../orchestration/navigation.service';
import * as import7 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import8 from '../../html-utils/css-var.directive';
import * as import9 from '../../ui-elements/icon/icon.component';
import * as import10 from '../../buttons/link/link.component.ngfactory';
import * as import11 from '../../buttons/link/link.component';
import * as import12 from 'ng2-translate/src/translate.pipe';
import * as import13 from 'ng2-translate/src/translate.service';
import * as import14 from '../../html-utils/element-width.directive';
import * as import15 from './loyalty-card.component';
import * as import16 from '../../identity/identity.model';
const styles_LoyaltyCardComponent:any[] = ([] as any[]);
export const RenderType_LoyaltyCardComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_LoyaltyCardComponent,
  data: {}
}
);
function View_LoyaltyCardComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'img',[[
        'class',
        'content-media-object'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import1.ImageCacheDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import2.CachedImageService
    ]
      ,{imageData: [
        0,
        'imageData'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.card.image;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_LoyaltyCardComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'content-media'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.card.image.id;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_LoyaltyCardComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[
      [
        'class',
        'content-details-header'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
      ,[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import4.ResponsiveDirective,[
      import0.ElementRef,
      import5.ResponsiveService,
      import6.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
      ,{fontScale: [
        0,
        'fontScale'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_1:any = 0.06;
    ck(v,1,0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'loyalty-card-name-',co.index,'');
    ck(v,0,0,currVal_0);
    const currVal_2:any = co.card.cardName;
    ck(v,2,0,currVal_2);
  });
}
function View_LoyaltyCardComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-icon',[[
        'class',
        'content-details-body-stamps-cell-container-placeholder-stamp'
      ]
    ],(null as any),(null as any),(null as any),import7.View_IconComponent_0,import7.RenderType_IconComponent)),
      import0.ɵdid(671744,(null as any),0,import8.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod([
      '--rotation',
      '--woa-icon-grunge-offset'
    ]
    ),
    import0.ɵdid(573440,(null as any),0,import9.IconComponent,[import0.ChangeDetectorRef],{
      name: [
        0,
        'name'
      ]
      ,
      grunge: [
        1,
        'grunge'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,2,0,co.getStampRotation((<any>v.parent).context.$implicit),co.getStampGrungeOffset((<any>v.parent).context.$implicit));
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.stampIcon;
    const currVal_2:any = true;
    ck(v,3,0,currVal_1,currVal_2);
  },(null as any));
}
function View_LoyaltyCardComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'content-details-body-stamps-cell'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'content-details-body-stamps-cell-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[
      [
        'class',
        'content-details-body-stamps-cell-container-placeholder'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import4.ResponsiveDirective,[
      import0.ElementRef,
      import5.ResponsiveService,
      import6.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
      ,{fontScale: [
        0,
        'fontScale'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_6)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 0.05;
    ck(v,5,0,currVal_0);
    const currVal_1:any = (v.context.$implicit < co.card.purchaseCount);
    ck(v,8,0,currVal_1);
  },(null as any));
}
function View_LoyaltyCardComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        2,
        0
      ]
      ,
      [
        'stamps',
        1
      ]

    ]
      ,(null as any),6,'div',[[
        'class',
        'content-details-body-stamps'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(671744,(null as any),0,import8.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod([
      '--rows',
      '--columns',
      '--placeholder-container-size'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_5)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,2,0,co.stampRows,co.stampColumns,(co.stampPlaceholderContainerSize + 'px'));
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.cells;
    ck(v,5,0,currVal_1);
  },(null as any));
}
function View_LoyaltyCardComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'content-details-body-points'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[
      [
        'class',
        'content-details-body-points-progressbar'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import4.ResponsiveDirective,[
      import0.ElementRef,
      import5.ResponsiveService,
      import6.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
      ,{fontScale: [
        0,
        'fontScale'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'content-details-body-points-progressbar-progress'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(671744,(null as any),0,import8.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod(['--percentage']),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 0.02;
    ck(v,3,0,currVal_0);
    const currVal_1:any = ck(v,7,0,(co.identityModel.cardCompletion(co.card) * 100));
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_LoyaltyCardComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'content-details-button-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'multi-row',
      'points'
    ]
    ),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    ))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'content-details-button-label';
    const currVal_1:any = ck(v,2,0,((co.card.cardType === co.LoyaltyCardType.STAMPS) && (co.stampRows > 1)),(co.card.cardType === co.LoyaltyCardType.POINTS));
    ck(v,1,0,currVal_0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.card.cardName;
    ck(v,3,0,currVal_2);
  });
}
function View_LoyaltyCardComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[[
        'class',
        'content-details-footer-link'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onRedeem.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_LinkComponent_0,import10.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import11.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.loyalty-cards.redeem';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_LoyaltyCardComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[
      [
        'class',
        'content-details-footer'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import4.ResponsiveDirective,[
      import0.ElementRef,
      import5.ResponsiveService,
      import6.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
      ,{fontScale: [
        0,
        'fontScale'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'content-details-footer-text'
      ]
    ],[
      [
        8,
        'id',
        0
      ]
      ,
      [
        8,
        'innerHTML',
        1
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod([
      'itemDescription',
      'purchaseCount',
      'pointsAvailable',
      'pointsRequired',
      'remaining',
      'stampsGoal',
      'goalDescription'
    ]
    ),
    import0.ɵpid(131072,import12.TranslatePipe,[
      import13.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_10)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 0.05;
    ck(v,1,0,currVal_0);
    const currVal_3:any = ((co.card.cardType === co.LoyaltyCardType.POINTS) && (co.card.pointsRequiredToRedeem <= co.identityModel.currentMember.pointsBalance));
    ck(v,9,0,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = import0.ɵinlineInterpolate(1,'loyalty-card-description-',co.index,'');
    const currVal_2:any = import0.ɵunv(v,3,1,import0.ɵnov(v,5).transform(co.footerText,ck(v,4,0,(co.card.itemDescription || (('{' + '{woa.message.loyalty-card.defaultItemDescription}') + '}')),co.span('content-details-description-text-purchaseCount',('loyalty-card-purchaseCount-' + co.index),co.card.purchaseCount),co.span('content-details-description-text-points',('loyalty-card-points-' + co.index),co.StringUtils.toScale(co.identityModel.currentMember.pointsBalance,4)),co.span('content-details-description-text-points',('loyalty-card-points-' + co.index),co.StringUtils.toScale(co.card.pointsRequiredToRedeem,4)),co.span('content-details-description-text-remaining',('loyalty-card-remaining-' + co.index),((co.card.cardType === co.LoyaltyCardType.STAMPS)? co.stampsRequired: co.pointsRequired)),co.span('content-details-description-text-goal',('loyalty-card-goal-' + co.index),co.card.goal),(co.card.goalDescription || (('{' + '{woa.message.loyalty-card.defaultGoalDescription}') + '}')))));
    ck(v,3,0,currVal_1,currVal_2);
  });
}
export function View_LoyaltyCardComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{content: 0}),
    import0.ɵqud(671088640,2,{stamps: 0}),
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'content',
        1
      ]

    ]
    ,(null as any),49,'div',[
      [
        'class',
        'content'
      ]
      ,
      [
        'woa-element-width',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['button']),
      import0.ɵdid(671744,(null as any),0,import8.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpad(2),
    import0.ɵpod([
      '--themed-loyalty-card-body-padding',
      '--themed-loyalty-card-background-color',
      '--themed-loyalty-card-max-column-spec',
      '--themed-loyalty-card-header-text-color',
      '--themed-loyalty-card-header-background-color',
      '--themed-loyalty-card-header-background-opacity',
      '--themed-loyalty-card-footer-text-color',
      '--themed-loyalty-card-footer-background-color',
      '--themed-loyalty-card-footer-background-opacity',
      '--themed-loyalty-card-placeholder-background-color',
      '--themed-loyalty-card-placeholder-border-color',
      '--themed-loyalty-card-placeholder-opacity',
      '--themed-loyalty-card-stamp-color',
      '--themed-loyalty-card-stamp-opacity',
      '--themed-loyalty-card-stamp-icon',
      '--themed-loyalty-card-stamp-icon-scale',
      '--themed-loyalty-card-stamp-icon-rotate-factor'
    ]
    ),
    import0.ɵdid(5455872,(null as any),0,import14.ElementWidthDirective,[
      import0.ElementRef,
      import0.ChangeDetectorRef,
      import5.ResponsiveService
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'content-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['no-image']),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'content-details-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_7)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_8)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoyaltyCardComponent_9)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import15.LoyaltyCardComponent = v.component;
    const currVal_0:any = 'content';
    const currVal_1:any = ck(v,4,0,co.buttonMode);
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_2:any = ck(v,23,1,[
      ck(v,6,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-body-padding'),'--woa-default-themed-loyalty-card-body-padding'),
      ck(v,7,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-background-color'),'--woa-default-themed-loyalty-card-background-color'),
      ck(v,8,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-max-column-spec'),'--woa-default-themed-loyalty-card-max-column-spec'),
      ck(v,9,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-header-text-color'),'--woa-default-themed-loyalty-card-header-text-color'),
      ck(v,10,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-header-background-color'),'--woa-default-themed-loyalty-card-header-background-color'),
      ck(v,11,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-header-background-opacity'),'--woa-default-themed-loyalty-card-header-background-opacity'),
      ck(v,12,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-footer-text-color'),'--woa-default-themed-loyalty-card-footer-text-color'),
      ck(v,13,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-footer-background-color'),'--woa-default-themed-loyalty-card-footer-background-color'),
      ck(v,14,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-footer-background-opacity'),'--woa-default-themed-loyalty-card-footer-background-opacity'),
      ck(v,15,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-placeholder-background-color'),'--woa-default-themed-loyalty-card-placeholder-background-color'),
      ck(v,16,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-placeholder-border-color'),'--woa-default-themed-loyalty-card-placeholder-border-color'),
      ck(v,17,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-placeholder-opacity'),'--woa-default-themed-loyalty-card-placeholder-opacity'),
      ck(v,18,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-stamp-color'),'--woa-default-themed-loyalty-card-stamp-color'),
      ck(v,19,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-stamp-opacity'),'--woa-default-themed-loyalty-card-stamp-opacity'),
      ck(v,20,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-stamp-icon'),'--woa-default-themed-loyalty-card-stamp-icon'),
      ck(v,21,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-stamp-icon-scale'),'--woa-default-themed-loyalty-card-stamp-icon-scale'),
      ck(v,22,0,(('--woa-' + co.cardTheme) + '-themed-loyalty-card-stamp-icon-rotate-factor'),'--woa-default-themed-loyalty-card-stamp-icon-rotate-factor')
    ]
    );
    ck(v,5,0,currVal_2);
    ck(v,24,0);
    const currVal_3:boolean = !co.buttonMode;
    ck(v,27,0,currVal_3);
    const currVal_4:any = 'content-details';
    const currVal_5:any = ck(v,31,0,(co.card.image.id == (undefined as any)));
    ck(v,30,0,currVal_4,currVal_5);
    const currVal_6:any = (co.card.cardName && !co.buttonMode);
    ck(v,34,0,currVal_6);
    const currVal_7:any = ((co.card.cardType === co.LoyaltyCardType.STAMPS) && (co.stampRows > 0));
    ck(v,39,0,currVal_7);
    const currVal_8:any = (co.card.cardType === co.LoyaltyCardType.POINTS);
    ck(v,42,0,currVal_8);
    const currVal_9:any = (co.card.cardName && co.buttonMode);
    ck(v,46,0,currVal_9);
    const currVal_10:boolean = !co.buttonMode;
    ck(v,49,0,currVal_10);
  },(null as any));
}
function View_LoyaltyCardComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-loyalty-card',([] as any[]),(null as any),(null as any),(null as any),View_LoyaltyCardComponent_0,RenderType_LoyaltyCardComponent)),
    import0.ɵdid(245760,(null as any),0,import15.LoyaltyCardComponent,[
      import0.ChangeDetectorRef,
      import5.ResponsiveService,
      import16.IdentityModel
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const LoyaltyCardComponentNgFactory:import0.ComponentFactory<import15.LoyaltyCardComponent> = import0.ɵccf('woa-loyalty-card',import15.LoyaltyCardComponent,View_LoyaltyCardComponent_Host_0,{
  card: 'card',
  index: 'index',
  buttonMode: 'buttonMode'
}
,{onRedeem: 'onRedeem'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/loyalty-card/loyalty-card/loyalty-card.component.ngfactory.ts